import { RestrictedData } from '@/features/restricted-data/RestrictedData'
import { Page } from '@/ui-kit'

const RestrictedDataPage = () => {
  return (
    <Page>
      <RestrictedData />
    </Page>
  )
}

export default RestrictedDataPage
